document.addEventListener('DOMContentLoaded', () => {
    const width = window.innerWidth;
    
    if (width <= 768) {
        document.querySelectorAll('.review-text').forEach(element => {
            const text = element.querySelector('.review-text p');
            const textContent = text.innerHTML;
            
            /*if (width > 768) {
                text.innerHTML = textContent.slice(0, 300) + '...';
            } else {
                text.innerHTML = textContent.slice(0, 150) + '...';
            }*/
            text.innerHTML = textContent.slice(0, 200) + '...';
            
            element.addEventListener('click', (e) => {
                if (element.classList.contains('active')) {
                    element.querySelector('.readmore').innerHTML = 'Lees meer';
                    /*if (width > 768) {
                        text.innerHTML = textContent.slice(0, 300) + '...';
                    } else {
                       text.innerHTML = textContent.slice(0, 150) + '...';
                    }*/
                    
                    text.innerHTML = textContent.slice(0, 200) + '...';
                } else {
                    element.querySelector('.readmore').innerHTML = 'Lees minder';
                    text.innerHTML = textContent;
                }
                
                element.classList.toggle('active');
            });
        });
    }
});
